import { TripContext } from 'contexts'
import { useContext } from 'react'
import { OrderItem, ReturnItem } from 'services/types'
import { useOrderItemService } from './useOrderItemService'

export const useOrderService = () => {

    const { deleteOrderItems } = useOrderItemService()

    const tripContext = useContext(TripContext)

    const deleteOrders = (orderIds: number[]): void => {
        const returns: ReturnItem[] = tripContext.returnItems.filter(rtn => orderIds.includes(rtn.orderId))
        const orderItems: OrderItem[] = tripContext.orderItems.filter(orderItem => orderIds.includes(orderItem.orderId))

        tripContext.orders.bulkRemove(orderIds),
        tripContext.returnItems.bulkRemove(returns.map(rtn => rtn.id)),
        deleteOrderItems(orderItems.map(oi => oi.id))
    }

    return {
        deleteOrders: deleteOrders
    }

}
